//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProtocolList from "./list"    
import { staticType } from "./config"    

export default {
    name:'instructionProtocol',
    data(){
        return {
            selectFlag:false,
            treatyList:[{flag:'notice',name:'投保须知'},{flag:'agreement',name:'保险条款'},{flag:'protocol',name:'服务协议'}],

          }
    },
    props: {
        templateFlag:{ 
            type: String,
            default() { return '' }
        },
        type:{
           type: String,
            default() { return 'pink' } 
        },
        staticName:{ //埋点配置信息
            type: String,
            default() { return 'proinfo' } 
        }
    },
    components:{
        ProtocolList
    },
    created(){},
    methods:{
        // 判断是否勾选
        checkSelectFlag(){
            return new Promise((resolve)=>{
                this.selectFlag?resolve(true):resolve(false)
            })
        },
        // 协议勾选框点击
        selectClick(){
            if(this.selectFlag){
                staticType[this.staticName].uncheck()
            }else{
                staticType[this.staticName].check()
            }
            this.selectFlag = !this.selectFlag

        },
        // 展示弹框
        treatyClick(item){
            staticType[this.staticName].treatyshow()

            this.$refs.protocolList.show(item)
        },
    }
}
